/* unplugin-vue-components disabled */
const __default__ = {
  mixins: [ModelValue(Boolean)],
  props: {
    checkedValue: {type: String, required: false, default: undefined},
    size: {type: String, default: 'default'},
    fontSize: {type: String, required: false, default: '1.6rem'},
    indeterminate: {type: Boolean, default: false},
  }
}

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "df3cab1a-fontSize": (_ctx.fontSize)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__